var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm._class},[_c('input',_vm._b({attrs:{"type":_vm.type,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}},'input',_vm.$attrs,false)),_vm._t("default"),_c('span')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }